import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Questionnaire } from './Questionnaire';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 10_000
        }
    }
});
export const QuestionnairePreview = ({ callBackParent, appImages, resetQuestionnaire = false, getDataQuestionnaire, isMapEnabled, googleKey, isWhiteLabel, PTID, hasLocalStorage, currency, defaultPicture, getDataOutcome }) => {
    return (_jsxs(QueryClientProvider, { client: queryClient, children: [_jsx(Questionnaire, { callBackParent: callBackParent, appImages: appImages, resetQuestionnaire: resetQuestionnaire, getDataQuestionnaire: getDataQuestionnaire, isMapEnabled: isMapEnabled, googleKey: googleKey, isWhiteLabel: isWhiteLabel, PTID: PTID, hasLocalStorage: hasLocalStorage, currency: currency, defaultPicture: defaultPicture, getDataOutcome: getDataOutcome }), _jsx(ToastContainer, { hideProgressBar: true })] }));
};
